export type PdfPageRange = {
  start: number;
  end: number;
};

export const pageNumbersToRanges = (
  pageNumbers: Iterable<number>,
): PdfPageRange[] => {
  const sorted = [...new Set(pageNumbers)]
    .filter(pageNumber => Number.isInteger(pageNumber) && pageNumber >= 1)
    .sort((left, right) => left - right);
  if (sorted.length === 0) return [];

  const ranges: PdfPageRange[] = [];
  for (const pageNumber of sorted) {
    const previous = ranges.at(-1);
    if (previous && pageNumber <= previous.end + 1) {
      previous.end = Math.max(previous.end, pageNumber);
    } else {
      ranges.push({ start: pageNumber, end: pageNumber });
    }
  }
  return ranges;
};

export const rangesToPageNumbers = (
  ranges: Iterable<PdfPageRange>,
): number[] => {
  const pageNumbers: number[] = [];
  for (const range of ranges) {
    for (
      let pageNumber = range.start;
      pageNumber <= range.end;
      pageNumber += 1
    ) {
      pageNumbers.push(pageNumber);
    }
  }
  return [...new Set(pageNumbers)].sort((left, right) => left - right);
};
